import React, { useState } from 'react';

import UserField from '../fields/UserField';
import DocumentField from '../fields/DocumentField';
import { Button, Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core';

const validateForm = ({ user, document, companyName, isCompany, email, phone }) => {
  let errors = {};

  if(!isCompany && !user) {
    errors = {
      ...errors,
      user: 'Selecione um usuário'
    }
  }

  if(isCompany && !companyName) {
    errors = {
      ...errors,
      user: 'Preencha o nome da empresa'
    }
  }

  if(!document || document?.includes('_')) {
    errors = {
      ...errors,
      document: 'Preencha um documento válido'
    }
  }

  if(isCompany && (!email || !email?.includes('@'))) {
    errors = {
      ...errors,
      email: 'Preencha um email válido'
    }
  }

  if((phone || '').replace(/\D/g, '').length < 10) {
    errors = {
      ...errors,
      phone: 'Informe o celular com DDD (exigido pela Pagar.me)'
    }
  }

  return {
    hasError: Object.values(errors).length > 0,
    errors
  };
}

export default function CustomerForms({ defaultCustomer, onSubmitCustomer }) {
  const [user, setUser] = useState(defaultCustomer?.user || null);
  const [document, setDocument] = useState(defaultCustomer?.document || '');
  const [email, setEmail] = useState(defaultCustomer?.email || '');
  const [isCompany, setIsCompany] = useState(defaultCustomer?.isCompany || false);
  const [companyName, setCompanyName] = useState(defaultCustomer?.companyName || '');
  const [phone, setPhone] = useState(defaultCustomer?.phone || '');
  const [formError, setFormError] = useState({
    user: '',
    document: '',
    email: ''
  });

  const hasError = Object.values(formError).some(Boolean);

  const resetFormErrors = () => {
    if(!hasError) {
      return;
    }

    setFormError({
      user: '',
      document: ''
    });
  }

  const handleChangeUser = (user) => {
    resetFormErrors();
    setUser(user);
    setDocument('');
    
    if(user?.cpf) {
      setDocument(user?.cpf);
    }

    setPhone(user?.celular || '');
  }

  const handleIsCompanyChange = (checked) => {
    resetFormErrors();

    setUser(null);
    setDocument('');
    setCompanyName('');
    setEmail('');
    setPhone('');
    setIsCompany(checked);
  }

  const handleChangeCompanyName = (e) => {
    resetFormErrors();

    setCompanyName(e.target.value);
  }

  const handleChangeDocument = (document) => {
    resetFormErrors();
    
    setDocument(document);
  }

  const handleChangeEmail = (e) => {
    resetFormErrors();
    
    setEmail(e.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const validateError = validateForm({user, document, isCompany, companyName, email, phone});

    if(validateError.hasError) {
      setFormError(validateError.errors);
      return;
    }

    onSubmitCustomer({
      user,
      document,
      isCompany,
      companyName,
      email,
      phone,
      address: user?.address
    });
  }

  /**
   * @todo Criar uma funcao para validar o documento
   */
  const hasUser = !!user && !!document && !!phone;
  const hasCompany = !!companyName && !!document && !!email && !!phone;

  const shouldAllowNextStep = (hasUser || hasCompany) && !hasError;

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <FormControlLabel
            label="Comprador é uma empresa?"
            control={
              <Checkbox
                color="primary" 
                checked={isCompany}
                onChange={(e) => handleIsCompanyChange(e.target.checked)}
              />
            }
          />
        </Grid>
        <Grid item>
          {isCompany ? (
            <TextField fullWidth label="Nome da Empresa" value={companyName} onChange={handleChangeCompanyName} error={!!formError?.user} helperText={formError?.user} />
          ) : (
            <UserField autoFocus selectedUser={user} onChangeUser={handleChangeUser} error={!!formError?.user} helperText={formError?.user}/>
          )}
        </Grid>
        {isCompany && (
          <Grid item>
            <TextField
              fullWidth
              label="Email"
              value={email}
              onChange={handleChangeEmail}
              error={!!formError?.email}
              helperText={formError?.email ? formError?.email : 'Email é usado como chave na pagarme'}
            />
          </Grid>
        )} 
        {(!!user || isCompany) && (
          <>
            <Grid item>
              <DocumentField
                label={isCompany ? "CNPJ" : "CPF"}
                mask={isCompany ? "99.999.999/9999-99" : "999.999.999-99"}
                document={document}
                onChangeDocument={handleChangeDocument}
                error={!!formError?.document}
                helperText={formError?.document}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                label="Celular com DDD"
                value={phone}
                onChange={(e) => { resetFormErrors(); setPhone(e.target.value); }}
                error={!!formError?.phone}
                helperText={formError?.phone || 'Exigido pela Pagar.me'}
              />
            </Grid>
          </>
        )}
        <Grid item container justifyContent="flex-end">
          <Grid item>
            <Button disabled={!shouldAllowNextStep} variant="contained" color="primary" type="submit">Salvar</Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  )
}